export default [{
	titulo: 'Pnab',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/pnab',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]